import { StatusBar } from 'expo-status-bar';
import React,{useEffect,useState}  from 'react';
import { StyleSheet, Text, View, Alert, TextInput,TouchableOpacity, BackHandler,ScrollView} from 'react-native';
import ButtonGradient from '../modules/component/ButtonGradient';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';

  const MenuFacturas = () => {
  const navigation = useNavigation();
  const [errorMsg, setErrorMsg] = useState(null);

  const showAlert = () => 
   
    Alert.alert(gMsg, 'Oprima Aceptar para continuar', [
      { text: "Aceptar" }
      ],
      { cancelable: true });

      function irFacturas(navigation,estatusFactura){

            global.gEstatusFactura = estatusFactura;
            navigation.navigate('FacturasListado');    
      
       
      }
    



    return(
  
    <View style={styles.container}>
        <Fondo/>

       
        <Text style={styles.subTitle}>{gOperador.toUpperCase()} - {gDeterminante}</Text>
        <Text style={styles.subTitle}> {gNombre}</Text>

        <Text style={styles.subTitle2}>Elige una opción</Text>

        <TouchableOpacity  style={styles.container2} onPress={()=>irFacturas(navigation,"EMITIDA")}>
          <ButtonGradient  texto="Facturas emitidas" />
        </TouchableOpacity>

        <TouchableOpacity  style={styles.container2} onPress={()=>navigation.navigate('DashboardTienda')}>
          <ButtonGradient texto="Facturas entregadas" />
        </TouchableOpacity>

        <StatusBar style="auto" />
       
      </View>
    
    );
  }

export default MenuFacturas

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center'
  },

  subTitle:{
    fontSize: 30,
    color: 'black',
    marginTop: 10,
    textAlign : 'center',
    fontWeight: 'bold'
  },

  subTitle2:{
    fontSize: 25,
    color: 'black',
    marginTop: 10,
    textAlign : 'center',
    fontWeight: 'bold',
    alignItems: 'center'

  },
  container2:{
    alignItems: 'center',
    justifyContent : 'center',
    marginTop:20,
    marginLeft:30,
    width: '80%',
   height: '30%'
}

  
});


